import React, { useState, useEffect } from 'react';
import './PaymentForm.scss';
import { FxInput, AlertService, http, FxSelect, FxDate } from '../../../fx-core';
import { Button } from '@material-ui/core';
import { FormValidator } from '../../../../utils/FormValidator';
import { useHistory } from 'react-router-dom';
import { general } from "../../../fx-core/helpers/generalService";
import { session } from "../../../fx-core/helpers/sessionService";

const PaymentForm = (props) => {
    const history = useHistory();
    const propsObj = props.location.state;
    const paymentId = propsObj.id;

    const defaultItem = {
        partyId: -1,
        paymentDate: paymentId > 0 ? "" : general.getCurrentDate(),
        paidAmount: 0,
        paymentModeId: -1,
        paymentNotes: "",
        id: 0
    };
    const [payment, setPayment] = useState(defaultItem);
    const [errors, setErrors] = useState({});
    const [parties, setParties] = useState([]);
    const [paymentMode, setPaymentMode] = useState([]);

    const validationMap = {
        partyId: ["required"],
        paymentDate: ["required"],
        paidAmount: ["required"],
        paymentModeId: ["required"]
    };

    const bulkValidate = () => {
        let records = [];
        for (var key in validationMap) {
            if (key === "paymentDate" || key === "paidAmount" || key === "bagPerKG") {
                payment[key] = payment[key] === null ? "" : payment[key] + '';
                let rec = { name: key, value: payment[key], validations: validationMap[key] }
                records.push(rec);
            }
            else if (key === "partyId" || key === "paymentModeId") {
                let val = payment[key] === -1 ? "" : payment[key] + '';
                let rec = { name: key, value: val, validations: validationMap[key] }
                records.push(rec);
            }
            else {
                let rec = { name: key, value: payment[key], validations: validationMap[key] }
                records.push(rec);
            }
        }
        let validationResult = FormValidator.bulkValidate(records);
        updateErrors(validationResult.errors);
        return validationResult.isValid;
    }

    const updateErrors = (validationData) => {
        setErrors(prevState => {
            return { ...prevState, ...validationData }
        });
    }

    const hasError = (field, validationMethod) => {
        return (
            errors &&
            errors[field] &&
            errors[field][validationMethod]
        );
    };

    const savePayment = () => {
        const isValid = bulkValidate();
        if (isValid) {
            let apiOptions: any = {
                url: `payment/save`,
                data: payment
            };
            http.post(apiOptions).then(res => {
                savePaymentCallBack(res);
            });
        }
    };

    const savePaymentCallBack = (res) => {
        AlertService.showSuccessMsg();
        if (paymentId > 0) {
            getPaymentById();
        }
        else {
            back();
        }
    };

    const getPaymentById = () => {
        let apiOptions: any = {
            url: `payment/${paymentId}`
        };
        http.get(apiOptions).then(res => {
            getPaymentByIdCallBack(res);
        });
    };

    const getPaymentByIdCallBack = (res) => {
        setPayment(res.data);
    };

    const handleInputChange = (item) => {
        handleItemObjChange({ [item.name]: item.value });
        if (item.name === "partyId" || item.name === "paymentModeId") {
            item.value = item.value === -1 ? "" : item.value + '';
        }
        else if (item.name === "paidAmount") {
            item.value = item.value === null ? "" : item.value + '';
        }
        item.validations = validationMap[item.name];
        const validationResult = FormValidator.validate(item);
        const validationData = { [item.name]: validationResult };
        updateErrors(validationData);
    };

    const handleItemObjChange = (data) => {
        setPayment(prevState => {
            return { ...prevState, ...data }
        });
    };

    const back = () => {
        history.goBack();
    };

    const initLookup = () => {
        let inputData = {
            lookups: {
                Parties: { default: true },
                PaymentMode: { default: true }
            },
            filters: {
                companyId: session.getItem("companyId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            setParties(response.data.Parties);
            setPaymentMode(response.data.PaymentMode);
        });
    }

    useEffect(() => {
        initLookup()
        if (paymentId > 0) {
            getPaymentById();
        }
    }, []);

    return (
        <div className="content-container paymentform-ui">
            <div className="title-font px-4 row justify-content-between py-1">
                <span className="pt-1">Payment</span>
            </div>
            <div className="col-sm-12 mx-auto row pt-3 mt-2">

                <div className="col-sm-4 mt-3">
                    <FxSelect name="partyId" variant="outlined" label="Party Name"
                        options={parties}
                        selectedValue={payment.partyId}
                        valueField="id"
                        displayField="text"
                        size="small"
                        onValueChange={handleInputChange} />
                    {
                        hasError("partyId", "required") &&
                        <div className="validation-msg">Field is required</div>
                    }
                </div>

                <div className="col-sm-4 mt-3">
                    <FxDate name="paymentDate" variant="outlined" label="Payment Date" size="small" fullWidth
                        value={payment.paymentDate}
                        onValueChange={handleInputChange}
                    />
                    {
                        hasError("billNo", "required") &&
                        <div className="validation-msg">Field is required</div>
                    }
                </div>

                <div className="col-sm-4 mt-3">
                    <FxInput name="paidAmount" variant="outlined" label="Amount" size="small" fullWidth
                        value={payment.paidAmount} type="number"
                        onValueChange={handleInputChange}
                    />
                    {
                        hasError("price", "required") &&
                        <div className="validation-msg">Field is required</div>
                    }
                </div>

                <div className="col-sm-4 mt-3">
                    <FxSelect name="paymentModeId" variant="outlined" label="Payment Mode"
                        options={paymentMode}
                        selectedValue={payment.paymentModeId}
                        valueField="id"
                        displayField="text"
                        size="small"
                        onValueChange={handleInputChange} />
                    {
                        hasError("paymentModeId", "required") &&
                        <div className="validation-msg">Field is required</div>
                    }
                </div>
                <div className="col-sm-4 mt-3">
                    <FxInput name="paymentNotes" variant="outlined" label="Payment Notes" size="small" fullWidth
                        value={payment.paymentNotes}
                        onValueChange={handleInputChange}
                    />
                </div>

            </div>
            <div className="row mt-4 pr-5 justify-content-end">
                <span className="pl-2">
                    <Button variant="contained" size="small" onClick={back}>Cancel</Button>
                </span>
                <span className="pl-2">
                    <Button variant="contained" size="small" color="primary" onClick={savePayment}>Save</Button>
                </span>
            </div>
        </div>
    )
};

export default PaymentForm;